import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import RoutePortal from "./RoutePortal";
import * as types from "../../constants/actionTypes";
import * as queryString from 'query-string';
import SwitchUserSpinner from "./SwitchUserSpinner";
import * as d from "../../reducers/domainReducer";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

class RoutePortalLoggedInByEXTID extends RoutePortal {

    constructor(props, context) {
        super(props, context);
        this.updateAllowed = this.updateAllowed.bind(this);
        const { location } = props;
        const searchParams = queryString.parse(location.search != null && location.search != "" ? location.search : location.searchParms);
        const locStateParamsId = location && location.state && location.state.Id ? location.state.Id : "";
        const extId = locStateParamsId ? locStateParamsId : searchParams && searchParams["?id"] ? searchParams["?id"] : searchParams && searchParams["id"] ? searchParams["id"] : null;

        this.state = {
            ...(this.state ? this.state : {}),
            Allowed: true,
            isValidPatient: extId ? false : true, //If we have external id, then need to validate the patient before load the comp.
            patientId: extId,
            patientName: ''
        };

        this.callbackForSwitchUser = this.callbackForSwitchUser.bind(this);
    }

    componentDidMount() {
        //debugger;
        //this.updateAllowed = this.updateAllowed.bind(this);
        this.setState({ Allowed: true });
        if (super.componentDidMount) {
            super.componentDidMount();
        }

        if (this.state.patientId) {
            this.findPatientByIdAndSwitchUser();
        }

        this.componentWillUpdate();
    }

    componentDidUpdate(prevProps, prevState) {
        if (super.componentDidUpdate) {
            super.componentDidUpdate(prevProps, prevState);
        }
        this.updateAllowed();
    }


    componentWillUpdate(oldProps) {
        //debugger;
        if (super.componentWillUpdate) {
            super.componentWillUpdate(oldProps);
        }
        this.updateAllowed();
        if (this.props.computedMatch) {
            if (!this.props.isLoggedIn) {
                let params = '';
                //debugger;
                //Handling query params after logged in.
                if (this.props.location && this.props.location.search) {
                    params = this.props.location.search;
                }
                //debugger;
                this.props.setRedirectUrl(this.props.computedMatch.url, params);
            }
        }
    }

    updateAllowed() {
        var { Allowed } = this.state;
        if (Allowed === undefined) { Allowed = false }
        var bAllowed = true;
        var { activeFeatures } = this.props;
        if (this.props.AllowedOnFeatures) {
            //debugger;
            bAllowed = false;
            var sFeatureList = this.props.AllowedOnFeatures.split(",");
            sFeatureList.forEach((sFeature) => {
                if (sFeature !== null || sFeature !== "") {
                    if (activeFeatures[sFeature]) {
                        bAllowed = true;
                    }
                }
            });
        }
        if (Allowed !== bAllowed) {
            this.setState({ Allowed: bAllowed });
        }
    }


    findPatientByIdAndSwitchUser() {
        const { myChartUsersList, currentMyChartUser, primaryUser } = this.props;
        const { patientId } = this.state;
        let myChartUsers = primaryUser && myChartUsersList ? [primaryUser].concat(myChartUsersList) : [];
        if (patientId && myChartUsers && currentMyChartUser && currentMyChartUser.externalId && currentMyChartUser.externalId.toLowerCase() !== patientId.toLowerCase()) {
            for (let pl = 0; pl < myChartUsers.length; pl++) {
                let plUser = myChartUsers[pl];
                if (plUser && plUser.externalId && plUser.externalId.toLowerCase() === patientId.toLowerCase()) {
                    this.props.isProxySwitchForMychartDeepLink(true);
                    const isPrimaryUser = primaryUser && primaryUser.externalId && primaryUser.externalId.toLowerCase() === patientId.toLowerCase() ? true : false;
                    this.setState({ patientName: plUser.displayName ? plUser.displayName : '' });
                    window.userToSwitch = { ...plUser, isPrimary: isPrimaryUser };
                    this.switchToMyChartUser();
                    break;
                }
            }
        } else {
            this.setState({ isValidPatient: true });
        }
    }

     switchToMyChartUser(){
        const user = window.userToSwitch || "";
        const { currentMyChartUser, bundle } = this.props;
        if (user.externalId !== currentMyChartUser.externalId) {
            this.props.switchToMyChartUser(user, user.index ? user.index : 0, this.callbackForSwitchUser);
            logUI("MBHWeb.Route.Proxy.MyChartUserSwitched", new Date(), Tools.getURLPath(), JSON.stringify({ user, bundle }));
            window.userToSwitch = null;
        }
    }

    callbackForSwitchUser() {
        console.log("Mychart Switched");
        setTimeout(() => {
            this.setState({ isValidPatient: true });
            this.props.isProxySwitchForMychartDeepLink(false);
        }, 1000);
    }


    render() {
        const { isProxyUser, activeFeatures, RequireMyChart, isMyChartInActive, primaryUser } = this.props;

        var { Allowed, isValidPatient, patientId, patientName } = this.state;
        if (Allowed === undefined) { Allowed = true }
        var MissingFeatures = activeFeatures == null || activeFeatures.length == 0;

        const isPrimaryUser = primaryUser && primaryUser.externalId && patientId && primaryUser.externalId.toLowerCase() === patientId.toLowerCase() ? true : false;

        if (this.props.computedMatch) {
            if (this.props.isLoggedIn) {
                if (!MissingFeatures && ((!this.props.hasMyChart || (isProxyUser && this.props.blockProxyUsers && isValidPatient)) || !Allowed || (RequireMyChart && isMyChartInActive))) {
                    // in the event that we don't have MyChart where we should, just go back to the root of the site
                    return <Redirect push to="/" />;
                }
                else if (isValidPatient === false) {
                    return <SwitchUserSpinner isPrimaryUser={isPrimaryUser} patientName={patientName} />;
                } else {
                    return super.render();
                }
            }
            else {
                return <Redirect push to='/login' />;
            }
        }
        else {
            return "";
        }
    }

}


const mapStateToProps = (state, ownProps) => {
    let pl = [];

    if (state.domain.pl) {
        state.domain.pl.forEach((c, index, arr) => {
            pl.push(d.hydrateProxyUser(c));
        });
    }

    if (pl.length > 0) {
        pl.shift();
    }
    return {
        myChartUsersList: pl,
        isLoggedIn: state.domain.li,
        hasMyChart: ownProps.RequireMyChart ? state.domain.hm : true,
        isProxyUser: state.domain.ip,
        activeFeatures: state.memberships.activeFeatures,
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        currentMyChartUser: d.hydrateProxyUser(state.domain.cu),
        isMyChartInActive: state.dashboard.isMyChartInActive,
        bundle: state.session.serverData ? state.session.serverData.bundle : "mybswhealth"
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setRedirectUrl: (currentURL, params) => {
            //debugger;
            dispatch({ type: types.SET_REDIRECT_URL, URL: currentURL, params });
        },
        hideBannerOnCrash: (value) => {
            dispatch({ type: types.HIDE_BANNER_ON_CRASH, value });
        },
        switchToMyChartUser: (user, index, callback) => {
            dispatch({ type: types.SWITCH_USER_SAGA, user, index, callback});
            dispatch({ type: types.SWITCH_TO_PHARMACY_USER, pharmacyUser: null });
        },
        isProxySwitchForMychartDeepLink: (value) => {
            dispatch({ type: types.IS_PROXY_SWITCH_FOR_MYCHART_DEEPLINK, isProxySwitchForMychartDeepLink: value });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RoutePortalLoggedInByEXTID);

